export default __webpack_public_path__ + "static/media/dd1.67ea938b.jpg";